
import { TableRow, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreVertical, Trash2 } from "lucide-react";
import { User } from "@/hooks/useUserManagement";
import { useAuth } from "@/context/AuthContext";

interface UsersTableRowProps {
  user: User;
  onDelete: (user: User) => void;
}

export function UsersTableRow({ user, onDelete }: UsersTableRowProps) {
  const { user: currentUser } = useAuth();
  
  // Verificar se o usuário atual é o proprietário da assinatura
  const isOwner = currentUser?.id === user.id;

  return (
    <TableRow>
      <TableCell className="font-medium">{user.email}</TableCell>
      <TableCell>{new Date(user.created_at).toLocaleDateString()}</TableCell>
      <TableCell>{new Date(user.updated_at).toLocaleDateString()}</TableCell>
      <TableCell>
        {!isOwner && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-8 w-8 p-0">
                <span className="sr-only">Abrir menu</span>
                <MoreVertical className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-background border shadow-md">
              <DropdownMenuItem 
                onClick={() => onDelete(user)} 
                className="cursor-pointer text-destructive focus:text-destructive"
              >
                <Trash2 className="mr-2 h-4 w-4" />
                Excluir
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </TableCell>
    </TableRow>
  );
}
